import { render } from "./StudentsProgress.vue?vue&type=template&id=16e76fc4&scoped=true&ts=true"
import script from "./StudentsProgress.vue?vue&type=script&lang=ts"
export * from "./StudentsProgress.vue?vue&type=script&lang=ts"

import "./StudentsProgress.vue?vue&type=style&index=0&id=16e76fc4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e76fc4"]])

export default __exports__